var exports = {
  "y": "divider__gQjcDV",
  "A": "dividerCollapsible__q2EnFf",
};

module.exports = exports;
